import { IApiService } from '~/services/interfaces/IApiService';

export class BaseHttpAdapter {
    protected apiService: IApiService;

    constructor(apiAdapter: IApiService) {
        this.apiService = apiAdapter;
    }
}
